"use client";
import Link from "next/link";
import { ArrowRight, Play, ListChecks, Star } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { demoRequests as data } from "@/lib/data/contact";

const accent = "var(--color-cyan)";

export function DemoRequests() {
  return (
    <Section id="demo-request" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-cyan)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid lg:grid-cols-2 gap-5">
          <Reveal delay={100}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <Play className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Demo Format</span>
              </div>
              <div className="mt-4 space-y-3">
                {data.format.map((f, i) => (
                  <div key={i} className="flex items-baseline gap-2 text-sm">
                    <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{f.label}</span>
                    <span className="text-[rgb(var(--fg-muted))]">{f.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <ListChecks className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>What the Demo Covers</span>
              </div>
              <div className="mt-4 space-y-2">
                {data.coverage.map((c, i) => (
                  <div key={i} className="flex items-baseline gap-2 text-sm text-[rgb(var(--fg-muted))]">
                    <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{c.step}</span>
                    <span><span className="font-semibold">{c.title}</span> — {c.body}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
        <div className="mt-5 grid lg:grid-cols-2 gap-5">
          <Reveal delay={200}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.request.title}</span>
              <p className="mt-2 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.request.body}</p>
            </div>
          </Reveal>
          <Reveal delay={250}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.briefing.title}</span>
              <p className="mt-2 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.briefing.body}</p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={400}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
